import { Box } from '@mui/material'
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Panel from 'components/Panel'
import Modal from 'components/Modal'
import Form from 'components/Form'
import { useSnackbar } from 'notistack'
import { setInfo, clearInfo } from 'slices/infoSlice'
import { normalizeData } from 'utilities/validator'
import usePopup from 'hooks/usePopup'
import useAxios from 'hooks/useAxios'
import { v4 as uuidv4 } from 'uuid';
import { warpUpFailResponse } from 'utilities/utils'
import useDataHandler from 'hooks/useDataHandler'

export default function ServiceType() {
	const dispatch = useDispatch()
	const { enqueueSnackbar } = useSnackbar();
	const { save } = useDataHandler()
	const info = useSelector(state => state.info.ctx)
	const { post, get, del } = useAxios();
	const [mode, setMode] = useState("initial")
	const { confirmPopup } = usePopup();
	const [allServiceType, setAllServiceType] = useState([]);
	const modalId = useMemo(() => uuidv4(), [])
	const roleUser = useSelector(state => state.user.roleName)

	const fetchData = async controller => {
		const result = await get("/serviceType/getAllServiceType", {}, { signal: controller.signal })
		if (result.status === 200) {
			const data = result.data.data || []
			setAllServiceType(data)
		}
	}

	useEffect(() => {
		const controller = new AbortController();
		fetchData(controller)
		return () => {
			controller.abort()
		}
	}, [])

	const onCloseModal = useCallback(() => {
		confirmPopup({
			title: "แจ้งเตือน",
			content: "ท่านต้องการยกเลิกการแก้ไขหรือไม่",
			onSubmit: () => {
				setMode("initial")
			}
		})
	}, [])

	const inputForm = [{
		rowData: [
			{
				type: "text",
				required: true,
				props: {
					id: "name",
					label: "ชื่อประเภทบริการ",
					variant: "outlined"
				}
			},
			mode === "edit" && {
				type: "dropdown",
				props: {
					id: "active",
					label: "สถานะ",
					options: [
						{ label: "ใช้งาน", value: true },
						{ label: "ไม่ใช้งาน", value: false }
					],
				}
			}
		]
	},
	{
		rowData: [
			{
				type: "button",
				props: {
					label: "บันทึก",
					onClick: () => {
						saveData()
					},
					className: "!bg-bpTheme-buttonSubmit"
				}
			}
		]
	}
	]
	const table = useMemo(() => [
		{
			rowData: [{
				type: "dataTable",
				props: {
					columns: [
						{
							id: 'no',
							label: 'เลขที่ประเภทบริการ',
							fields: ["no"]
						},
						{
							id: 'name',
							label: 'ประเภทบริการ',
							fields: ["name"]
						},
						{
							id: 'active',
							label: 'สถานะ',
							fields: ["active"],
							valuesMap: [{ label: "ใช้งาน", value: true }, { label: "ไม่ใช้งาน", value: false }]

						}
					],
					rows: allServiceType,
					size: "small",
					showDeleteButton: roleUser === "Owner",
					title: "ข้อมูลประเภทบริการ",
					showSystemFields: true,
					onClick: (e) => {
						setMode("edit")
						dispatch(setInfo(e))
					},
					onDelete: (e, onSuccess) => {
						confirmPopup({
							onSubmit: async () => {
								const result = await del("/serviceType/deleteServiceType", { ids: e.map(data => data.id).join(',') })
								if (result.status === 200) {
									enqueueSnackbar('ลบสำเร็จ', { variant: "success" })
									dispatch(clearInfo())
									await fetchData(new AbortController())
									onSuccess()
								} else {
									enqueueSnackbar('ลบไม่สำเร็จ', { variant: "error" })
								}
							}
						})
					},
					controller: (paging) => get("/serviceType/getAllServiceType", { paging }),
					searchFields: [
						{ label: "ประเภทบริการ", value: "name" },
						{ label: "สถานะ", value: "active" }
					]
				}
			}]
		}, {
			noCol: true,
			rowData: [
				{
					type: "button",
					props: {
						label: "เพิ่มใหม่",
						onClick: () => {
							setMode("create")
							dispatch(clearInfo())
						}
					}
				},
			]
		}
	], [allServiceType])

	const saveData = useCallback(() => {
		save({
			data: info,
			scope: modalId,
			onSubmit: async () => {
				const data = normalizeData(info)
				let response
				if (mode === "create") {
					response = await post("/serviceType/createServiceType", { ...data, active: true })
				} else if (mode === "edit") {
					response = await post("/serviceType/updateServiceType", { ...data })
				}
				if (response.status === 200) {
					setMode("initial")
					enqueueSnackbar('บันทึกสำเร็จ', { variant: "success" })
					fetchData(new AbortController())
				} else {
					enqueueSnackbar(warpUpFailResponse(response, 'บันทึกไม่สำเร็จ'), { variant: "error" })
				}
			},
			onCancel: () => {
				enqueueSnackbar('ยกเลิกรายการ', { variant: "info" })
			}
		})
	}, [info, mode])

	return (
		<Box>
			<Panel data={table}></Panel>
			<Modal id={modalId} open={mode === "create" || mode === "edit"} onClose={onCloseModal} className="form-modal" contentClassName="min-w-full md:!min-w-[750px]">
				<Form title={"ประเภทบริการ " + (info.no || "")} name="user-form" data={inputForm}></Form>
			</Modal>
		</Box>
	)
}
